import {useEffect} from 'react'
import {useAuth} from './core/Auth'

export function Logout() {
  const {logout} = useAuth()
  useEffect(() => {
    logout({ voluntary: true, redirect: true })
  }, [logout])

  return null
}
